import IzzyAnalyzeGif from '@/assets/images/izzy/analyze.gif'
import { cn } from '@/lib/utils'

interface IzzyAnalyzeProps {
  className?: string
}

export const IzzyAnalyze = ({ className }: IzzyAnalyzeProps) => {

  return (
    <div className={cn('select-none', className)}>
      <img src={IzzyAnalyzeGif} alt='Izzy analizando equivalências de disciplinas do histórico acadêmico' />
    </div>
  )
}
